import { Pipe, PipeTransform } from '@angular/core';
import { isString, last } from 'lodash-es';

@Pipe({
  name: 'modeName',
})
export class ModeNamePipe implements PipeTransform {
  transform(val: string, ...args: any[]): any {
    if (val !== null && val !== undefined && isString(val)) {
      const prefix = args && args[0] ? `${args[0]}-` : '';
      const value = val.split('.');

      return prefix + last(value).replace(/\//gm, '-') || '';
    }

    return '';
  }
}
